<span [class]="className">
  {{ message }}
</span>
